import { useBrandContacts } from './contactsWidget.queries'

export const useContactsWidgetData = (
  isEditMode: boolean,
  brand: any,
  retailerProfile: any,
) => {
  // change this

  const {
    brandBuyers,
    brandSalesReps,
    loading: loadingContacts,
  } = useBrandContacts(brand?.id, !isEditMode, retailerProfile?.id)

  return {
    brandBuyers,
    brandSalesReps,
    loadingContacts,
  }
}
